import { IBestDataset } from '../../../../types/analytics';

const WRF_PATTERN = /wrf/i;

export function isWrfDatasetName(name: string): boolean {
  return WRF_PATTERN.test(name);
}

export function isSelectableReportDataset(dataset: IBestDataset): boolean {
  return !isWrfDatasetName(dataset.value);
}

export function filterSelectableReportDatasets(
  datasets: IBestDataset[]
): IBestDataset[] {
  return datasets.filter((dataset) => {
    const selectable = isSelectableReportDataset(dataset);
    return selectable;
  });
}

const CATEGORY_LABEL_BY_KEY: Record<string, string> = {
  SW: 'Waves',
  HD: 'Ocean',
  Wind: 'Atmosphere',
};

export function filterDefaultReportDatasets(
  defaults: Array<{ key: string; value: string }>,
  selectableDatasets: IBestDataset[]
): Array<{ key: string; value: string }> {
  const allowedDatasetIds = new Set(selectableDatasets.map((d) => d.id));
  return defaults.reduce<Array<{ key: string; value: string }>>((acc, d) => {
    if (allowedDatasetIds.has(d.value)) {
      acc.push(d);
      return acc;
    }

    const categoryLabel = CATEGORY_LABEL_BY_KEY[d.key];
    const fallback = selectableDatasets.find(
      (dataset) => dataset.label === categoryLabel
    );
    if (fallback) {
      acc.push({ key: d.key, value: fallback.id });
    }
    return acc;
  }, []);
}
